export const colors = ["#ffffff", "#f28b82", "#fbbc04", "#fff475"];
